import * as React from 'react';
import axios from 'axios';
import { Questions } from './Questions';

export const QuizContainer = (props) => {
    const [quiz,setQuiz] = React.useState<any>(null);

    React.useEffect(() => {
        axios.get(`${zmp_ajax.ajaxurl}?action=quiz_get&quiz_id=${props.quizId}`)
            .then(res => {
                const quiz = res.data;
                setQuiz( quiz );
            });
    },[])

    return <div className="quiz-container">
        { quiz && (<Questions quizId={props.quizId} data={quiz.question} feedbackImage={quiz && quiz.image.length>0 ? quiz.image[0] : null} result={[]} />)}
    </div>
}
